import type { AdapterConfig } from '@claudafinil/shared/contract';

type AdapterPlatform = AdapterConfig['platform'];

const ADAPTER_CONFIG_CATALOG: Record<AdapterPlatform, AdapterConfig> = {
  claude: {
    platform: 'claude',
    version: 'remote-claude-v1',
    selectors: {
      chatInput: '[data-testid="chat-input"]',
      messageContainer: '[data-is-streaming],[data-test-render-count]',
      messageIdAttribute: 'data-message-id',
    },
    endpoints: {
      conversationGet:
        '^https://claude\\.ai/api/organizations/[^/]+/chat_conversations/[^/?]+',
      branchSwitch:
        '^https://claude\\.ai/api/organizations/[^/]+/chat_conversations/[^/]+/current_leaf_message_uuid$',
    },
    parsing: {},
  },
  chatgpt: {
    platform: 'chatgpt',
    version: 'remote-chatgpt-v1',
    selectors: {
      chatInput: '#prompt-textarea',
      messageContainer: '[data-message-id]',
      messageIdAttribute: 'data-message-id',
    },
    endpoints: {
      conversationGet: '^https://chatgpt\\.com/backend-api/conversation/[^/]+$',
      branchSwitch: '^https://chatgpt\\.com/backend-api/unified_user_signals',
    },
    parsing: {},
  },
};

function cloneConfig(config: AdapterConfig): AdapterConfig {
  return {
    ...config,
    selectors: { ...config.selectors },
    endpoints: { ...config.endpoints },
    ...(config.parsing !== undefined ? { parsing: { ...config.parsing } } : {}),
  };
}

export function getAdapterConfigForPlatform(
  platform: AdapterPlatform,
): AdapterConfig {
  return cloneConfig(ADAPTER_CONFIG_CATALOG[platform]);
}
